var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149px",
    height: "48px",
    viewBox: "0 0 149 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_all",
    transform: "translate(-64.000000, -64.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(64.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon9",
    fill: "#00579F",
    points: "64.200338 47.2568604 52.1987476 47.2568604 59.7054021 0.841347805 71.7063362 0.841347805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.70717,1.97607465 C105.339929,1.03692247 101.585289,-1.70384741e-05 96.9426875,-1.70384741e-05 C85.0907314,-1.70384741e-05 76.7446809,6.32006365 76.6934902,15.3558758 C76.5950466,22.022478 82.6690182,25.7252709 87.2118633,27.9481279 C91.8551209,30.2195505 93.4335004,31.7021115 93.4335004,33.7267687 C93.3862474,36.8362746 89.6814857,38.2696138 86.2261145,38.2696138 C81.4345351,38.2696138 78.8671254,37.5306303 74.9654764,35.8006477 L73.3851281,35.0590391 L71.7056799,45.4783123 C74.5205113,46.7607046 79.7065214,47.8987129 85.0907314,47.948591 C97.6836398,47.948591 105.882025,41.7262976 105.979156,32.0971986 C106.027065,26.8134011 102.819772,22.764743 95.9050917,19.4563809 C91.7074555,17.3326238 89.1367643,15.9005972 89.1367643,13.7276182 C89.1859861,11.7521828 91.3110558,9.72883822 96.0494756,9.72883822 C99.9511246,9.6297383 102.817803,10.5675779 104.989469,11.5060738 L106.074974,11.9989482 L107.70717,1.97607465 L107.70717,1.97607465 L107.70717,1.97607465 Z",
    id: "path11",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.658318,30.8134937 C124.646692,28.1469841 128.449898,17.8268108 128.449898,17.8268108 C128.400019,17.9259107 129.436303,15.1110793 130.028933,13.3830656 L130.867673,17.3825019 C130.867673,17.3825019 133.140408,28.4928493 133.633939,30.8134937 C131.75826,30.8134937 126.028841,30.8134937 123.658318,30.8134937 L123.658318,30.8134937 Z M138.472771,0.841347805 L129.189537,0.841347805 C126.326797,0.841347805 124.151849,1.68008749 122.91671,4.69246239 L105.089882,47.2562041 L117.68279,47.2562041 C117.68279,47.2562041 119.756013,41.5274415 120.201634,40.2936147 C121.583127,40.2936147 133.833451,40.2936147 135.610687,40.2936147 C135.95524,41.9231849 137.042713,47.2562041 137.042713,47.2562041 L148.15503,47.2562041 L138.472771,0.841347805 L138.472771,0.841347805 L138.472771,0.841347805 Z",
    id: "path13",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1745614,0.841347805 L30.421049,32.4922856 L29.1366878,26.073105 C26.9637089,18.6662067 20.1487849,10.6187686 12.5436868,6.6173634 L23.3094815,47.2076386 L36.0008336,47.2076386 L54.8652572,0.841347805 L42.1745614,0.841347805 L42.1745614,0.841347805 L42.1745614,0.841347805 Z",
    id: "path15",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5069325,0.841347805 L0.197543676,0.841347805 L1.36029634e-07,1.7791874 C15.062531,5.63095828 25.0381516,14.9155046 29.1366878,26.0750739 L24.9390517,4.74299679 C24.2479774,1.77853111 22.1242203,0.939135139 19.5069325,0.841347805 L19.5069325,0.841347805 Z",
    id: "path17",
    fill: "#FAA61A"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f6dbb47b3614a244f0b2ebf193336fe6.svg";
export { ForwardRef as ReactComponent };